import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import site from './site'
import user from './user'
import tickets from './tickets'

export default combineReducers( {
	loadingBar: loadingBarReducer,
	site,
	user,
	tickets
} )
